'use client'

// https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript/javascript-replay#session-replay-with-a-cdp
import mixpanel from 'mixpanel-browser'

import { resolveWhen } from '@segment/analytics-consent-tools'
import {
  getNormalizedActiveGroupIds,
  getOneTrustGlobal,
} from '@src/lib/consent-wrapper-onetrust/onetrust-api'

import { getAnalytics } from '../PageTrack/getAnalytics'

let analytics: ReturnType<typeof getAnalytics>

export const initMixpanelAnalytics = async () => {
  if (typeof window === 'undefined') return

  await resolveWhen(() => getOneTrustGlobal() !== undefined, 500)
  await resolveWhen(() => getNormalizedActiveGroupIds().includes('C0002'), 500)
  analytics = getAnalytics()

  if (!analytics) return

  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || ''

  // https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#installing-the-library
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: {
      // Don't autocapture normal element clicks
      click: false,
      // Keep Dead Click signals
      dead_click: true,
      // keep rage clicks (user frustration signals)
      rage_click: true,
      // Turn off other noisy stuff if Segment is already handling it
      pageview: false,
      input: false,
      scroll: false,
      submit: false,
      // when user click is true and click on text content area
      capture_text_content: false,
    },
    track_pageview: false,
    record_sessions_percent: 0.2,
    record_heatmap_data: true,
    record_mask_text_selector: '',
  })

  analytics.addSourceMiddleware(({ payload, next }) => {
    if (payload.obj.type === 'track' || payload.obj.type === 'page') {
      const segmentDeviceId = payload.obj.anonymousId
      // -------------------------------------------
      // Comment out one of the below mixpanel.register methods depending on your ID Management Version
      // Original ID Merge
      mixpanel.register({
        $device_id: segmentDeviceId,
        distinct_id: segmentDeviceId,
      })
      // Simplified ID Merge
      // mixpanel.register({
      //   $device_id: segmentDeviceId,
      //   distinct_id: '$device:' + segmentDeviceId,
      // })
      // -------------------------------------------
      const sessionReplayProperties =
        mixpanel.get_session_recording_properties()

      payload.obj.properties = {
        ...payload.obj.properties,
        ...sessionReplayProperties,
      }
    }
    if (payload.obj.type === 'identify') {
      if (payload.obj.userId != null) {
        const userId = payload.obj.userId
        mixpanel.identify(userId)
      }
    }
    next(payload)
  })

  return analytics
}

export { analytics }
